(function multirangePolyfill(f){ /in/.test(document.readyState)?setTimeout(multirangePolyfill,5,f) : f()})(polyfillMultirange = function() {
	[].forEach.call(document.querySelectorAll('.pagecreator_formelement:has([type="range"])'), function(el) {
		let checkboxes = el.querySelectorAll('[type="checkbox"]'),
			range1 = el.querySelector('input[type="range"]'),
			range2 = el.querySelector('input[type="range"] + input[type="range"]'),
			minGap = 1,
			maxValue = Math.max(parseInt(range1.getAttribute('max') || '100'), parseInt(range2.getAttribute('max') || '100')),
			fillColor = function(e) {
				e.stopPropagation();
				e.preventDefault();
				e.stopImmediatePropagation();

				if(e.target === range1 && parseInt(range2.value) - parseInt(range1.value) <= minGap) {
					range1.value = parseInt(range2.value) - minGap;
				}
				if(e.target === range2 && parseInt(range2.value) - parseInt(range1.value) <= minGap) {
					range2.value = parseInt(range1.value) + minGap;
				}

				let percent1 = (parseInt(range1.value) / maxValue) * 100;
				let percent2 = (parseInt(range2.value) / maxValue) * 100;

				el.style.setProperty('--value-1', percent1.toFixed(0));
				el.style.setProperty('--value-2', percent2.toFixed(0));

				checkboxes.forEach(function(checkbox, index) {
					checkbox.checked = index >= parseInt(range1.value) && index <= parseInt(range2.value)-1;
				});
				// trigger change event on first checked checkbox to update filter
				checkboxes[parseInt(range1.value)].dispatchEvent(new Event('change', {
					bubbles: true,
					cancelable: true
				}));
			};

		if(!range1 || !range2) return;

		// input event for both range inputs
		['input', 'change'].forEach(function(e) {
			range1.addEventListener(e, fillColor);
			range2.addEventListener(e, fillColor);
		});
		// trigger input event to set initial values
		range1.dispatchEvent(new Event('input'));
	});
});

